import { TransferStatus } from '../../typing';
import { parseDomain } from '../../utils';
import { CheckTransferInStatus } from '@wix/ambassador-domain-delivery/types';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { Specs } from '../../constants/Specs';
export const canTransferInDomainViaWixWar = async _ref => {
  let httpClient = _ref.httpClient,
    domain = _ref.request.domain;
  const _ref2 = getPremiumEssentialsSafe() ?? {},
    experiments = _ref2.experiments;
  const isBlockTransferGateEnabled = experiments == null ? void 0 : experiments[Specs.BLOCK_TRANSFER_GATE];
  if (!domain) {
    return {
      canTransferIn: false
    };
  }
  const parsedDomain = domain.main ? domain : parseDomain(domain);
  const _await$dynamicLoadApi = await dynamicLoadApiQueries(httpClient),
    checkDomainIsTaken = _await$dynamicLoadApi.checkDomainIsTaken,
    listTransferIns = _await$dynamicLoadApi.listTransferIns,
    checkTransferInStatus = _await$dynamicLoadApi.checkTransferInStatus;
  const _await$checkDomainIsT = await checkDomainIsTaken({
      domain: parsedDomain.asciiDomain
    }),
    isAvailable = _await$checkDomainIsT.isAvailable;
  if (isAvailable) {
    return {
      canTransferIn: false
    };
  }
  const _await$Promise$all = await Promise.all([listTransferIns({}), checkTransferInStatus({
      domainName: parsedDomain.asciiDomain
    })]),
    transfers = _await$Promise$all[0].transfers,
    status = _await$Promise$all[1].status;
  const transferInRequest = transfers == null ? void 0 : transfers.find(transfer => transfer.domainName === parsedDomain.asciiDomain);
  const transferInStatusValidation = TransferStatus.COMPLETED !== (transferInRequest == null ? void 0 : transferInRequest.transferStatus) && TransferStatus.PENDING !== (transferInRequest == null ? void 0 : transferInRequest.transferStatus);
  const supportedTransferInStatuses = isBlockTransferGateEnabled ? [CheckTransferInStatus.OK] : [CheckTransferInStatus.DOMAIN_LOCKED, CheckTransferInStatus.OK];
  const canTransferIn = supportedTransferInStatuses.includes(status ?? CheckTransferInStatus.TRANSFER_NOT_ALLOWED) && transferInStatusValidation;
  const blockByTransferInStatus = status !== CheckTransferInStatus.OK ? status : !transferInStatusValidation ? transferInRequest.transferStatus : undefined;
  return {
    canTransferIn,
    status: blockByTransferInStatus,
    error: status === CheckTransferInStatus.DOMAIN_LOCKED ? 'lockedByProvider' : undefined
  };
};
//# sourceMappingURL=canTransferInDomainViaWixWar.js.map